import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import HallRoomTypeListTable from './Components/HallRoomTypeListTable'

const HallRoomTypeList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Hall Room Type List</HeadingOne>
                    <AddItemBtn url="add-hall-room-type" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <HallRoomTypeListTable />
            </div>
        </PageBody>
    )
}

export default HallRoomTypeList
